import { Button, Checkbox } from '@mui/material'
import { FC, useContext, useEffect, useState } from 'react'

import { useTranslation } from 'react-i18next'
import closeIcon from '../../../../../assets/images/icons/x-close.svg'
import { useDashboardContext } from '../../../../../providers/contexts/Dashboard'
import { UserDataContext } from '../../../../../providers/contexts/UserDataProvider'
import { handleb2b2cOptIn } from '../../../../../services/dashboard'
import { OPT_IN_OPTIONS, ROUTES } from '../../../../../utils/constants/enum'
import CustomModal from '../../../../modals/custom-modal'
import styles from './mL-opt-in.module.scss'

type MLOptInModalProps = {
    open: boolean
    closeModal: () => void
}

export const MLOptIn: FC<MLOptInModalProps> = ({ open, closeModal }) => {
    const { t } = useTranslation()
    const [isTnCChecked, setIsTnCChecked] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [isErrorVisible, setIsErrorVisible] = useState(false)
    const [error, setError] = useState('')
    const { userData, setUserData } = useContext(UserDataContext)
    const { setShowMLOptInStatus } = useDashboardContext(
        ({ setShowMLOptInStatus }) => ({
            setShowMLOptInStatus,
        })
    )

    const handleOptIn = async (isMultiAccount: boolean) => {
        setError('')
        setIsErrorVisible(false)
        setIsLoading(true)

        const response = isMultiAccount
            ? await handleb2b2cOptIn(OPT_IN_OPTIONS.OPT_IN, true)
            : await handleb2b2cOptIn(OPT_IN_OPTIONS.OPT_IN)
        if (response.success) {
            setUserData(response.data)
            if (isMultiAccount) {
                setShowMLOptInStatus(true)
            }
            closeModal()
        } else {
            setError(response.message)
            setIsErrorVisible(true)
        }
        setIsLoading(false)
    }

    useEffect(() => {
        setError('')
        setIsTnCChecked(false)
        setIsErrorVisible(false)
    }, [open])

    return (
        <CustomModal open={open}>
            <div className={styles['header']}>
                <h1 className={styles['title']}>
                    {`${t('rewards_program_opt.welcome')}, ${
                        userData.businessName
                    }`}
                </h1>
                <img
                    className={styles['close']}
                    onClick={closeModal}
                    src={closeIcon}
                    alt="x"
                />
            </div>
            <div className={styles['main']}>
                <div className={styles['terms-container']}>
                    <div className={styles['terms-text']}>
                        <p>
                            {t(
                                'rewards_program_opt.multi_location_opt_in_content_1'
                            )}
                        </p>
                        <p>
                            {t(
                                'rewards_program_opt.multi_location_opt_in_content_2'
                            )}
                        </p>
                    </div>
                    <div className={styles['terms-checkbox-container']}>
                        <Checkbox
                            className={styles['terms-checkbox']}
                            checked={isTnCChecked}
                            id="signB2b2c"
                            onChange={() => setIsTnCChecked(!isTnCChecked)}
                        />
                        <span>
                            {t('rewards_program_opt.agree_to_text')}{' '}
                            <a
                                href={`${ROUTES.TERMS_AND_CONDITIONS}en`}
                                target="_blank"
                                rel="noreferrer"
                                className={styles['link']}
                            >
                                {t(
                                    'rewards_program_opt.multi_location_terms_conditions'
                                )}
                            </a>
                        </span>
                    </div>
                </div>

                <div className={styles['button-container-wrapper']}>
                    <div className={styles['button-container']}>
                        <Button
                            variant="contained"
                            disabled={!isTnCChecked || isLoading}
                            type="submit"
                            className="secondary-btn"
                            id="myBtn"
                            onClick={() => handleOptIn(true)}
                        >
                            {t('rewards_program_opt.opt_in_all_my_locations')}
                        </Button>
                        <Button
                            variant="contained"
                            disabled={!isTnCChecked || isLoading}
                            type="submit"
                            className="secondary-btn"
                            id="myBtn"
                            onClick={() => handleOptIn(false)}
                        >
                            {t('rewards_program_opt.opt_in_this_location')}
                        </Button>
                    </div>
                    {isErrorVisible ? (
                        <p className={styles['error-text']}>
                            {error
                                ? error
                                : t('common_elements.something_wrong_text')}
                        </p>
                    ) : null}
                </div>
            </div>
        </CustomModal>
    )
}
